var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authorize == 'merchant')?_c('ChangeToBusinessForm',{ref:"ChangeToBusinessForm"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }